import { Lock } from 'lucide-react';
import { useT } from '@/lib/i18n';

/** Shown on a form the user may open but not change (section rights, #95). */
export function ReadOnlyNotice() {
  const t = useT();
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-md border bg-muted/40 p-3 text-sm text-muted-foreground"
    >
      <Lock className="h-4 w-4 shrink-0" />
      {t('perms.readOnly')}
    </div>
  );
}
